/* global localStorage */

import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK } from 'react-admin'

import axiosClient from '../config/axios'

export default (type, params) => {
  if (type === AUTH_LOGIN) {
    const { username, password } = params
    return axiosClient().post(`/login`, {email: username, password})
      .then(response => {
        if (response.status < 200 || response.status >= 300) {
          throw new Error(response.statusText)
        }
        localStorage.setItem('auth', 'bearer ' + response.data.token)
        return response.data.user
      })
      .catch((err) => {
        console.log(err)
        if (err.response) throw new Error(err.response.statusText)
        else throw new Error('Unknown error')
      })
  }
  if (type === AUTH_LOGOUT) {
    axiosClient().post(`/logout`)
      .catch((err) => {
        console.log(err)
      })
    localStorage.removeItem('auth')
  }
  if (type === AUTH_ERROR) {
    const { status } = params
    if (status === 401 || status === 403) {
      localStorage.removeItem('auth')
      return Promise.reject() // eslint-disable-line
    }
    return Promise.resolve()
  }
  if (type === AUTH_CHECK) {
    return localStorage.getItem('auth') ? Promise.resolve() : Promise.reject({ redirectTo: '/login' }) // eslint-disable-line
  }
  return Promise.resolve()
}
